import React from 'react'
import { X, CheckCircle2, PartyPopper } from 'lucide-react'
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SuccessModal = (props: SuccessModalProps) => {
    // console.log('SuccessModal rendering with purchasedPlan:', purchasedPlan);
    const { t } = useTranslation();
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    return (
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4"
        onClick={() => {
          setShowSuccessModal(false);
          props.onClose();
        }}
      >
      <div 
        className="bg-white rounded-2xl max-w-md w-full p-8 text-center relative"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={() => {
            setShowSuccessModal(false);
            props.onClose();
          }}
          className="absolute top-4 right-4 p-1 hover:bg-gray-100 rounded-full transition-colors"
        >
          <X className="w-5 h-5 text-gray-500" />
        </button>
        
        <div className="mb-6">
          <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
            <CheckCircle2 className="w-8 h-8 text-green-600" />
          </div>
          <div className="flex justify-center mb-2">
            <PartyPopper className="w-6 h-6 text-yellow-500 animate-bounce" />
          </div>
        </div>
        
        <h3 className="text-2xl font-bold text-gray-900 mb-2">
          {t('subscription.success.title', 'Payment Successful!')}
        </h3>        

        <p className="text-gray-600 mb-6">
          {t('subscription.success.message')}
        </p>

        <button
          onClick={() => {
            setShowSuccessModal(false);
            props.onClose();
          }}
          className="w-full bg-gradient-to-r from-green-500 to-green-600 text-white py-3 px-6 rounded-lg font-semibold hover:from-green-600 hover:to-green-700 transition-all transform hover:scale-105"
        >
          {t('subscription.success.continue', 'Continue')}
        </button>
      </div>
    </div>
    );
  };
export default SuccessModal